import type { TranslationFunction } from 'global';
import { useTranslations } from 'next-intl';

let cachedT: TranslationFunction | null = null;

export const setGlobalT = (t: TranslationFunction) => {
  if (!t) {
    throw new Error(
      `Translation instance is not provided because t is not a Translate instance: t = `,
    );
  }

  cachedT = t;
};

export const translate: TranslationFunction = (...params) => {
  if (!cachedT || !(cachedT instanceof Function)) {
    return '';
    // throw new Error('Translation has not been initialized. Call initTranslation first.');
  }

  return cachedT(...params);
};

export const TranslationProvider = ({ children }: { children: React.ReactNode }) => {
  const t = useTranslations();

  setGlobalT(t);

  return <>{children}</>;
};
